export default function getPercentileColor(pacing) {
  if (!pacing) return "#e5e3e1";
  else if (pacing === "BELOW_GRADE_LEVEL") return "var(--below-grade)";
  else if (pacing === "AT_GRADE_LEVEL") return "var(--at-grade)";
  else if (pacing === "AHEAD_OF_GRADE_LEVEL") return "var(--ahead-grade)";
  else if (pacing === "DIFFERENTIATION_NEEDED") return "var(--differentiate)";
  else {
    console.log("pacing: ", pacing);
    return "pink";
  }
}
